module.exports = __webpack_public_path__ + "media/31.39519cc6.mp3";